import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { _optionalChain } from '@sentry/utils';
import { loadModule, logger, fill, isThenable } from '@sentry/utils';
import { DEBUG_BUILD } from '../../common/debug-build.js';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';

/** Tracing integration for node-postgres package */
var Postgres = /*#__PURE__*/function () {
  _createClass(Postgres, null, [{
    key: "__initStatic",
    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'Postgres';
    }
    /**
     * @inheritDoc
     */
  }]);
  function Postgres() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Postgres);
    this.name = Postgres.id;
    this._usePgNative = !!options.usePgNative;
    this._module = options.module;
  }

  /** @inheritdoc */
  _createClass(Postgres, [{
    key: "loadDependency",
    value: function loadDependency() {
      return this._module = this._module || loadModule('pg');
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line deprecation/deprecation
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        DEBUG_BUILD && logger.log('Postgres Integration is skipped because of instrumenter configuration.');
        return;
      }
      var pkg = this.loadDependency();
      if (!pkg) {
        DEBUG_BUILD && logger.error('Postgres Integration was unable to require `pg` package.');
        return;
      }
      var Client = this._usePgNative ? _optionalChain([pkg, 'access', function (_2) {
        return _2.native;
      }, 'optionalAccess', function (_3) {
        return _3.Client;
      }]) : pkg.Client;
      if (!Client) {
        DEBUG_BUILD && logger.error("Postgres Integration was unable to access 'pg-native' bindings.");
        return;
      }

      /**
       * function (query, callback) => void
       * function (query, params, callback) => void
       * function (query) => Promise
       * function (query, params) => Promise
       * function (pg.Cursor) => pg.Cursor
       */
      fill(Client.prototype, 'query', function (orig) {
        return function (config, values, callback) {
          // eslint-disable-next-line deprecation/deprecation
          var scope = getCurrentHub().getScope();
          // eslint-disable-next-line deprecation/deprecation
          var parentSpan = scope.getSpan();
          var data = {
            'db.system': 'postgresql'
          };
          try {
            if (this.database) {
              data['db.name'] = this.database;
            }
            if (this.host) {
              data['server.address'] = this.host;
            }
            if (this.port) {
              data['server.port'] = this.port;
            }
            if (this.user) {
              data['db.user'] = this.user;
            }
          } catch (e) {
            // ignore
          }

          // eslint-disable-next-line deprecation/deprecation
          var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
            return _4.startChild;
          }, 'call', function (_5) {
            return _5({
              description: typeof config === 'string' ? config : config.text,
              op: 'db',
              origin: 'auto.db.postgres',
              data: data
            });
          }]);
          if (typeof callback === 'function') {
            return orig.call(this, config, values, function (err, result) {
              _optionalChain([span, 'optionalAccess', function (_6) {
                return _6.end;
              }, 'call', function (_7) {
                return _7();
              }]);
              callback(err, result);
            });
          }
          if (typeof values === 'function') {
            return orig.call(this, config, function (err, result) {
              _optionalChain([span, 'optionalAccess', function (_8) {
                return _8.end;
              }, 'call', function (_9) {
                return _9();
              }]);
              values(err, result);
            });
          }
          var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
          if (isThenable(rv)) {
            return rv.then(function (res) {
              _optionalChain([span, 'optionalAccess', function (_10) {
                return _10.end;
              }, 'call', function (_11) {
                return _11();
              }]);
              return res;
            });
          }
          _optionalChain([span, 'optionalAccess', function (_12) {
            return _12.end;
          }, 'call', function (_13) {
            return _13();
          }]);
          return rv;
        };
      });
    }
  }]);
  return Postgres;
}();
Postgres.__initStatic();
export { Postgres };